import { render, staticRenderFns } from "./TabLayout.vue?vue&type=template&id=4199e86a&"
import script from "./TabLayout.vue?vue&type=script&lang=js&"
export * from "./TabLayout.vue?vue&type=script&lang=js&"
import style0 from "./TabLayout.vue?vue&type=style&index=0&id=4199e86a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports